import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { toast } from 'sonner';
import axios from 'axios';
import { API } from '../App';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success('Password reset link sent to your email (Mock)');
    } catch (error) {
      toast.error('Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--secondary) 0%, white 100%)', paddingTop: '5rem' }}>
        <div className="card" style={{ maxWidth: '450px', width: '100%', margin: '2rem' }}>
          <h2 style={{ marginBottom: '1rem', textAlign: 'center' }}>Forgot Password?</h2>
          <p style={{ textAlign: 'center', color: 'var(--muted-foreground)', marginBottom: '2rem' }}>
            {submitted ? 'Check your email for reset instructions' : 'Enter your email to receive reset instructions'}
          </p>

          {!submitted ? (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="email-input"
                />
              </div>

              <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading} data-testid="submit-btn">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
              <Link to="/auth" className="btn-primary">Back to Login</Link>
            </div>
          )}

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <Link to="/auth" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>← Back to Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;